var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1153 0.46021C21.6944 0.226007 21.2315 0.0770679 20.753 0.0219112C20.2745 -0.0332456 19.7898 0.00646154 19.3267 0.138762C18.8636 0.271063 18.431 0.493362 18.0539 0.792946C17.6767 1.09253 17.3623 1.46352 17.1286 1.88471L10.3215 14.135L6.42564 10.2392C6.0874 9.88901 5.6828 9.60967 5.23546 9.41751C4.78811 9.22534 4.30697 9.12419 3.82011 9.11996C3.33325 9.11573 2.85043 9.2085 2.39981 9.39287C1.94919 9.57723 1.5398 9.84949 1.19552 10.1938C0.851251 10.538 0.578989 10.9474 0.394626 11.398C0.210263 11.8487 0.11749 12.3315 0.12172 12.8183C0.125951 13.3052 0.227101 13.7863 0.419267 14.2337C0.611434 14.681 0.890768 15.0856 1.24097 15.4239L8.57431 22.7572C9.26731 23.452 10.2023 23.8334 11.1666 23.8334L11.6745 23.7967C12.2365 23.7181 12.7726 23.5101 13.2405 23.1891C13.7085 22.8681 14.0956 22.4429 14.3713 21.9469L23.538 5.44688C23.772 5.02604 23.9209 4.56322 23.976 4.08486C24.0312 3.60649 23.9916 3.12194 23.8595 2.65889C23.7274 2.19583 23.5053 1.76332 23.2061 1.38607C22.9068 1.00882 22.5362 0.694213 22.1153 0.46021Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.b5171aad6582ab13b3612b77105db08b.svg";
export { ForwardRef as ReactComponent };